import { lazy, Suspense, type ComponentType } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { Home } from '@/pages/Home';

/** Wrap a named lazy export in Suspense for route-level code splitting. */
function lazyPage(loader: () => Promise<Record<string, ComponentType>>, name: string) {
  const Component = lazy(() => loader().then((m) => ({ default: m[name] as ComponentType })));
  return (
    <Suspense fallback={<RouteFallback />}>
      <Component />
    </Suspense>
  );
}

function RouteFallback() {
  return (
    <div style={{ padding: 'var(--space-16)', textAlign: 'center', color: 'var(--color-text-muted)' }}>
      Loading…
    </div>
  );
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'catalog', element: lazyPage(() => import('@/pages/Catalog'), 'Catalog') },
      { path: 'p/:slug', element: lazyPage(() => import('@/pages/ProductDetail'), 'ProductDetail') },
      { path: 'checkout', element: lazyPage(() => import('@/pages/Checkout'), 'Checkout') },
      { path: 'order/:id', element: lazyPage(() => import('@/pages/Confirmation'), 'Confirmation') },
      { path: 'about', element: lazyPage(() => import('@/pages/StaticPages'), 'About') },
      { path: 'contact', element: lazyPage(() => import('@/pages/StaticPages'), 'Contact') },
      { path: 'terms', element: lazyPage(() => import('@/pages/StaticPages'), 'Terms') },
      { path: 'refunds', element: lazyPage(() => import('@/pages/StaticPages'), 'Refunds') },
      { path: '*', element: lazyPage(() => import('@/pages/StaticPages'), 'NotFound') },
    ],
  },
]);

export function App() {
  return <RouterProvider router={router} />;
}
